import { Grid, Stack } from "@mui/material";
import React from "react";
import { useStakingSliceActions } from "src/store/features/staking.slice";
import { StyledTableDataLabel } from "../staking/staking-styled-components";
import { SmallSohneTextSpan } from "../staking/staking-styled-components";
import { UnstakeButton } from "../staking/staking-styled-components";
import { StakeButton } from "../staking/staking-styled-components";
import { useDispatch } from "react-redux";

import { YourCryptoPanel as StyledBorderContainer } from "src/components/portfolio/styles/portifolio.styles";

export const SummaryMobileCard = ({ coin }: { coin: string }) => {
  const { setStakeModalOpen, setUnstakeModalOpen } = useStakingSliceActions();
  const dispatch = useDispatch();
  return (
    <StyledBorderContainer style={{ marginBottom: "14px" }}>
      <Grid container>
        <Grid item xs={12}>
          <StyledTableDataLabel style={{ color: "#002035" }}>{coin}</StyledTableDataLabel>
        </Grid>

        {/* APY Row */}
        <Grid item xs={6}>
          <SmallSohneTextSpan>APY</SmallSohneTextSpan>
        </Grid>
        <Grid item xs={6} textAlign={"right"}>
          <SmallSohneTextSpan>1%</SmallSohneTextSpan>
        </Grid>
        {/* Available Balance Row */}
        <Grid item xs={6}>
          <SmallSohneTextSpan>Total staked</SmallSohneTextSpan>
        </Grid>
        <Grid item xs={6} textAlign={"right"}>
          <SmallSohneTextSpan>Value Abb Icon</SmallSohneTextSpan>
        </Grid>
        {/* Min to Stake Row */}
        <Grid item xs={6}>
          <SmallSohneTextSpan>Available balance</SmallSohneTextSpan>
        </Grid>
        <Grid item xs={6} textAlign={"right"}>
          <SmallSohneTextSpan>Value Abb</SmallSohneTextSpan>
        </Grid>
        {/* Buttons */}
        <Grid item xs={12} mt={2}>
          <Stack direction={"row"} gap={1} justifyContent={"center"}>
            <UnstakeButton variant="mobile" onClick={() => dispatch(setUnstakeModalOpen(true))}>
              Unstake
            </UnstakeButton>
            <StakeButton variant="mobile" onClick={() => dispatch(setStakeModalOpen(true))}>
              Stake
            </StakeButton>
          </Stack>
        </Grid>
      </Grid>
    </StyledBorderContainer>
  );
};
